<template>
  <div class="mapWrapper" @click="handleMapWrapperClick">
    <mdb-container class="mapHeadingContainer">
      <mdb-row class="mt-4 mb-3 justify-content no-gutters">
        <mdb-col
          lg="8"
          class="
            d-flex
            justify-content-center justify-content-lg-end
            align-items-center
            order-1 order-lg-0
          "
        >
          <h2 class="isi-heading-white">Cities with studios in</h2>
          <select
            id="continentSelect"
            @input="handleContinentChange"
            placeholder="Select continent"
            v-model="selectedContinent"
          >
            <option
              v-for="el in $store.state.continents"
              :key="el.id"
              :value="el.id"
            >
              {{ el.displayName }}
            </option>
          </select>
        </mdb-col>

        <mdb-col class="d-flex justify-content-end">
          <div id="mapsClose">X</div>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <div id="map" ref="map"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!document.getElementById("scriptBingMaps")) {
      var scriptElement = document.createElement("script");
      scriptElement.src =
        "https://www.bing.com/api/maps/mapcontrol?callback=OnLoadBingMapsApi";
      scriptElement.id = "scriptBingMaps";
      document.head.appendChild(scriptElement);
      window.OnLoadBingMapsApi = this.initMap;
    } else {
      this.initMap();
    }
    /*eslint-disable*/
  },
  data() {
    return {
      mapObject: null,
      selectedContinent: 1,
    };
  },
  computed: {
    startGeoData() {
      let geoData;

      if (this.$store.state.searchParams.countries.length > 0) {
        let continents = [];
        for (let el of this.$store.state.searchParams.countries) {
          let country = this.$store.state.countries.find((x) => x.id == el);
          let continent = this.$store.state.continents.find(
            (x) => x.id == country.continentData.id
          );

          if (!continents.includes(continent)) {
            continents.push(continent);
          }
        }
        if (continents.length == 1) {
          geoData = continents[0];
          this.selectedContinent = continents[0].id;
        } else {
          geoData = {
            geoCoordinate: {
              latitude: 30.2970178833,
              longitude: -34.5832133828,
            },
            mapZoomLevel: 2,
          };
          this.selectedContinent = 1;
        }
      } else {
        geoData = this.$store.state.countries.find(
          (x) => x.name == "Germany"
        ).continentData;
        this.selectedContinent = 1;
      }

      return geoData;
    },
  },
  methods: {
    handleContinentChange(e) {
      if (e.target.value == null) return;
      let id = parseInt(e.target.value);
      let continent = this.$store.state.continents.find((x) => x.id == id);
      this.mapObject.setView({
        center: new Microsoft.Maps.Location(
          continent.geoCoordinate.latitude,
          continent.geoCoordinate.longitude
        ),
        zoom: continent.mapZoomLevel,
      });
    },
    handleMapWrapperClick(e) {
      if (e.target.id == "mapWrapper" || e.target.id == "mapsClose") {
        this.$emit("closeMap");
      }
    },
    initMap() {
      let mapElement = this.$refs.map;

      let geoData = this.startGeoData;

      var map = new Microsoft.Maps.Map(mapElement, {
        credentials:
          "Ah2VnZfqHKCarCcZWprq3v0xDbJhQYxZkfuT1PDuoJ1ppzw0SeW0JBi1BxqdU_yG",
        center: new Microsoft.Maps.Location(
          geoData.geoCoordinate.latitude,
          geoData.geoCoordinate.longitude
        ),
        mapTypeId: Microsoft.Maps.MapTypeId.road,
        labelOverlay: Microsoft.Maps.LabelOverlay.hidden,
        zoom: geoData.mapZoomLevel,
      });
      for (let el of this.$store.state.cities) {
        var pin = new Microsoft.Maps.Pushpin(
          new Microsoft.Maps.Location(
            el.geoCoordinate.latitude,
            el.geoCoordinate.longitude
          ),
          {
            title: el.displayName,
            color: "#264396",
            //subTitle: ''
          }
        );

        map.entities.push(pin);
        this.mapObject = map;
      }
    },
    /*eslint-enable*/
  },
  watch: {
    /*eslint-disable*/
    startGeoData(geoData) {
      this.mapObject.setView({
        center: new Microsoft.Maps.Location(
          geoData.geoCoordinate.latitude,
          geoData.geoCoordinate.longitude
        ),
        zoom: geoData.mapZoomLevel,
      });
      /*eslint-enable*/
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/components/_bingLocationMap.scss";
</style>